import { Component, Inject, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CategoriaFinanceira } from '../../../../../shared/services/models/financas/categoria-financeira.model';
import { CategoriaFinanceiraService } from '../../../../../shared/services/apis/financas/categoria-financeira.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';

export interface MigracaoCategoriaModalData {
  idCategoriaOrigem: number;
  idTipoCategoriaFinanceira: number;
  mensagemExibicao: string;
}

@Component({
  selector: 'app-migracao-categoria-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './migracao-categoria-modal.component.html',
  styleUrl: './migracao-categoria-modal.component.css',
})
export class MigracaoCategoriaModalComponent implements OnInit {
  public form: FormGroup;
  public isLoading = false;
  public filtroPesquisa = '';
  public categoriasFiltradas: CategoriaFinanceira[] = [];

  constructor(
    public dialogRef: MatDialogRef<MigracaoCategoriaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MigracaoCategoriaModalData,
    private fb: FormBuilder,
    private categoriaService: CategoriaFinanceiraService,
    private alertService: AlertService
  ) {
    this.form = this.fb.group({
      idCategoriaDestino: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.categoriaService.getLookups().subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }

        this.configurarCategoriasHabilitadas(res.categoriasPai);
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Falha ao buscar as categorias disponíveis.', AlertType.error);
      },
    });
  }

  private configurarCategoriasHabilitadas(listaBruta: CategoriaFinanceira[]): void {
    const idsPais = new Set(listaBruta.map(c => c.idCategoriaFinanceiraPai).filter(id => id !== null));

    this.categoriasFiltradas = listaBruta.filter(
      c =>
        c.idTipoCategoriaFinanceira === this.data.idTipoCategoriaFinanceira &&
        c.idCategoriaFinanceira !== this.data.idCategoriaOrigem &&
        !idsPais.has(c.idCategoriaFinanceira)
    );
  }

  confirmarMigracao(): void {
    if (this.form.invalid) return;

    const idDestino = this.form.get('idCategoriaDestino')?.value;
    this.dialogRef.close(idDestino);
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }
}
